export const get_slides=`/v2/slides`;
export const edit_slide=(id)=>`/v2/slides/${id}`
export const create_job=`/v2/opportunities`
